import { Controller } from "@hotwired/stimulus";

/**
 * Toggles billing address fields based on business account checkbox
 */
export default class extends Controller {
  static targets = ["billingField", "normalCountryField", "businessCountryField", "taxIdField", "checkboxToggle"];

  static values = {
    taxIdLabel: String,
    taxIdLabelEu: String,
    taxIdLabelCh: String,
    taxIdLabelB2b: String,
    b2bOnlyCountries: Array
  };

  connect() {
    this.checkboxChangeHandler = this.handleCheckboxChange.bind(this);
    this.countryChangeHandler = this.changeTaxIdLabel.bind(this);

    this.checkboxToggleTarget.addEventListener(
      "change",
      this.checkboxChangeHandler
    );

    this.businessCountryFieldTarget.querySelector("select").addEventListener(
      "change",
      this.countryChangeHandler
    );

    // make sure the billing fields are disabled if the checkbox is not checked
    this.handleCheckboxChange();
  }

  disconnect() {
    this.checkboxToggleTarget.removeEventListener(
      "change",
      this.checkboxChangeHandler
    );

    this.businessCountryFieldTarget.querySelector("select").removeEventListener(
      "change",
      this.countryChangeHandler
    );
  }

  toggleBillingFields(show) {
    this.billingFieldTarget
      .querySelectorAll("input, select")
      .forEach((field) => {
        if (show) {
          field.removeAttribute("disabled");
        } else {
          field.setAttribute("disabled", "disabled");
        }
      });
  }

  handleCheckboxChange() {
    const checked = this.checkboxToggleTarget.checked;
    this.toggleBillingFields(checked);

    if (checked) {
      const countrySelect = this.billingFieldTarget.querySelector("select");
      const currentOption = countrySelect.querySelector('option:checked');

      // Keep current selection if it's a valid option
      if (currentOption && currentOption.value && currentOption.value !== "") {
        countrySelect.dispatchEvent(new Event("change", { bubbles: true }));
        return;
      }

      // Default to DE if nothing valid is selected
      const deOption = countrySelect.querySelector('option[value="DE"]');
      if (deOption) {
        deOption.selected = true;
        countrySelect.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
  }

  changeTaxIdLabel() {
    const businessCountrySelect = this.businessCountryFieldTarget.querySelector("select");
    const taxIdLabel = this.taxIdFieldTarget.querySelector('label');
    const country = businessCountrySelect.value;
    const b2bCountries = this.b2bOnlyCountriesValue || [];

    if (country === "CH") {
      taxIdLabel.textContent = this.taxIdLabelChValue || "UID*";
    } else if (country === "DE") {
      taxIdLabel.textContent = this.taxIdLabelValue || "Umsatzsteuer-ID (optional)";
    } else if (b2bCountries.includes(country)) {
      taxIdLabel.textContent = this.taxIdLabelB2bValue || "Steuernummer*";
    } else {
      taxIdLabel.textContent = this.taxIdLabelEuValue || "USt-IdNr.*";
    }
  }
}
